<script>
    import AppIcon from "../icons/AppIcon.svelte";
    import {setFocusTo} from "../../lib/lib";

    export let id = '';
    export let value = '';
    export let placeholder = '';
    export let required = false;

    let viewPassword = false;

    const togglePassword = () => {
        viewPassword = !viewPassword;
        setFocusTo(id);
    }
</script>
<div class="input-group">
    {#if viewPassword}
        <input type="text" class="form-control" id="{ id }" name="password" bind:value="{ value }" {placeholder} {required}>
    {:else}
        <input type="password" class="form-control" id="{ id }" name="password" bind:value="{ value }" {placeholder} {required}>
    {/if}
    <div class="btn btn-default d-flex align-items-center" on:click="{ togglePassword }">
        <AppIcon icon="eye" strokeWidth="2"/>
    </div>
</div>